var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 10.8953H20C20.2652 10.8953 20.5196 11.0006 20.7071 11.1882C20.8946 11.3757 21 11.63 21 11.8953V21.8953C21 22.1605 20.8946 22.4148 20.7071 22.6024C20.5196 22.7899 20.2652 22.8953 20 22.8953H4C3.73478 22.8953 3.48043 22.7899 3.29289 22.6024C3.10536 22.4148 3 22.1605 3 21.8953V11.8953C3 11.63 3.10536 11.3757 3.29289 11.1882C3.48043 11.0006 3.73478 10.8953 4 10.8953H5V9.89526C5 8.97601 5.18106 8.06576 5.53284 7.21648C5.88463 6.3672 6.40024 5.59553 7.05025 4.94552C7.70026 4.29551 8.47194 3.77989 9.32122 3.42811C10.1705 3.07632 11.0807 2.89526 12 2.89526C12.9193 2.89526 13.8295 3.07632 14.6788 3.42811C15.5281 3.77989 16.2997 4.29551 16.9497 4.94552C17.5998 5.59553 18.1154 6.3672 18.4672 7.21648C18.8189 8.06576 19 8.97601 19 9.89526V10.8953ZM17 10.8953V9.89526C17 8.56918 16.4732 7.29741 15.5355 6.35973C14.5979 5.42205 13.3261 4.89526 12 4.89526C10.6739 4.89526 9.40215 5.42205 8.46447 6.35973C7.52678 7.29741 7 8.56918 7 9.89526V10.8953H17ZM11 14.8953V18.8953H13V14.8953H11Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockFill);
export default __webpack_public_path__ + "static/media/lock-fill.c4d6ffe5.svg";
export { ForwardRef as ReactComponent };